module.exports = __webpack_public_path__ + "img/image48.d1299a3e.png";